import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const NAV_ITEMS = [
  { key: 'news', icon: '📰' },
  { key: 'trainings', icon: '🎓' },
  { key: 'exhibitions', icon: '🏛️' },
  { key: 'projects', icon: '📁' },
  { key: 'loans', icon: '🔄' },
  { key: 'catalog', icon: '📦' },
  { key: 'contact', icon: '📞' },
];

export default function Layout({ page, setPage, children }) {
  const { user, logout, lang, setLang, t } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navItems = [
    ...NAV_ITEMS,
    ...(user?.role === 'admin' ? [{ key: 'admin', icon: '⚙️' }] : []),
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5', fontFamily: "'Outfit','Segoe UI',sans-serif" }}>
      {/* Top bar */}
      <header style={{
        background: '#fff',
        borderBottom: '1px solid #e5e7eb',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        boxShadow: '0 1px 8px rgba(0,0,0,0.06)',
      }}>
        <div style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '0 16px',
          height: 60,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          {/* Logo */}
          <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => setPage('news')}>
            <img src="/Grandstreampartner.png" alt="Grandstream Partner Program" style={{ height: 44 }} />
          </div>

          {/* Desktop nav */}
          <nav style={{ display: 'flex', gap: 2, alignItems: 'center' }} className="desktop-nav">
            {navItems.map(item => (
              <button
                key={item.key}
                onClick={() => setPage(item.key)}
                style={{
                  padding: '6px 14px',
                  border: 'none',
                  background: page === item.key ? '#e8f4fc' : 'transparent',
                  color: page === item.key ? '#0e76bc' : '#4b5563',
                  borderRadius: 8,
                  fontSize: 14,
                  fontWeight: page === item.key ? 700 : 500,
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                  fontFamily: 'inherit',
                  borderBottom: page === item.key ? '2px solid #0e76bc' : '2px solid transparent',
                }}
              >
                {t(item.key)}
              </button>
            ))}
          </nav>

          {/* Right side */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {/* Lang */}
            <div style={{ display: 'flex', gap: 2 }}>
              {['cs', 'sk', 'ro', 'en', 'hu'].map(l => (
                <button key={l} onClick={() => setLang(l)} style={{
                  padding: '3px 8px',
                  border: '1px solid',
                  borderColor: lang === l ? '#0e76bc' : '#e5e7eb',
                  borderRadius: 5,
                  background: lang === l ? '#0e76bc' : 'transparent',
                  color: lang === l ? '#fff' : '#6b7280',
                  fontSize: 11,
                  fontWeight: 700,
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                  fontFamily: 'inherit',
                }}>
                  {l.toUpperCase()}
                </button>
              ))}
            </div>

            {/* User */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '4px 10px',
              background: '#f9fafb',
              borderRadius: 8,
              border: '1px solid #e5e7eb',
            }}>
              <div style={{
                width: 28, height: 28, borderRadius: '50%',
                background: 'linear-gradient(135deg, #0e76bc, #0b5e96)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#fff', fontSize: 12, fontWeight: 700,
              }}>
                {user?.first_name?.[0]}{user?.last_name?.[0]}
              </div>
              <div style={{ lineHeight: 1.2 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#111827' }}>
                  {user?.first_name} {user?.last_name}
                </div>
                <div style={{ fontSize: 11, color: '#9ca3af' }}>{user?.company_name}</div>
              </div>
              <button onClick={logout} title={t('logout')} style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#9ca3af',
                fontSize: 16,
                padding: '0 2px',
                display: 'flex',
                alignItems: 'center',
              }}>
                ⏻
              </button>
            </div>

            {/* Mobile hamburger */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              style={{
                display: 'none',
                background: 'none',
                border: 'none',
                fontSize: 22,
                cursor: 'pointer',
                color: '#374151',
              }}
              className="mobile-menu-btn"
            >
              ☰
            </button>
          </div>
        </div>

        {/* Mobile nav */}
        {mobileOpen && (
          <div style={{
            borderTop: '1px solid #e5e7eb',
            background: '#fff',
            padding: '8px 16px 12px',
          }}>
            {navItems.map(item => (
              <button
                key={item.key}
                onClick={() => { setPage(item.key); setMobileOpen(false); }}
                style={{
                  display: 'block',
                  width: '100%',
                  textAlign: 'left',
                  padding: '10px 12px',
                  border: 'none',
                  background: page === item.key ? '#e8f4fc' : 'transparent',
                  color: page === item.key ? '#0e76bc' : '#374151',
                  borderRadius: 8,
                  fontSize: 15,
                  fontWeight: page === item.key ? 700 : 500,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                }}
              >
                {item.icon} {t(item.key)}
              </button>
            ))}
          </div>
        )}
      </header>

      {/* Page content */}
      <main style={{ maxWidth: 1200, margin: '0 auto', padding: '28px 16px' }}>
        {children}
      </main>

      {/* Footer */}
      <footer style={{
        borderTop: '1px solid #e5e7eb',
        background: '#fff',
        marginTop: 40,
        padding: '24px 16px',
      }}>
        <div style={{
          maxWidth: 1200,
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 16,
        }}>
          <div style={{ fontSize: 12, color: '#9ca3af', lineHeight: 1.6 }}>
            <div>© {new Date().getFullYear()} Grandstream Partner Portal</div>
            <div>Tento portál provozuje autorizovaný distributor. Nejedná se o oficiální stránky výrobce Grandstream Networks.</div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
          <img src="/GSdistrilogo.png" alt="Grandstream Certified Distributor" style={{ height: 48, opacity: 0.85 }} />
          <a href="/gdpr" target="_blank" style={{ fontSize: 11, color: '#9ca3af', textDecoration: 'none' }}>GDPR</a>
        </div>
        </div>
      </footer>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
        }
      `}</style>
    </div>
  );
}
